import { Component } from '@angular/core';

@Component({
  selector: 'app-scorp-cgv-en',
  templateUrl: './scorp-cgv-en.component.html',
  styleUrls: ['./scorp-cgv-en.component.scss'],
  standalone: false,
})
export class ScorpCgvEnComponent {}
